import cardSecrets from "#assets/lander/card-1.webp";
import cardCollaboration from "#assets/lander/card-2.webp";
import cardChallenges from "#assets/lander/card-3.webp";
import { Button } from "#components/Button.tsx";
import CommonBackground from "#components/design/CommonBackground.tsx";
import Footer from "#components/layout/Footer.tsx";
import { useModal } from "#components/Modal.tsx";
import { Starfield } from "#components/starfield/Starfield.tsx";
import { ThemeButtonVariant, ThemeSize } from "#components/theme.ts";
import JoinModal from "./JoinModal.tsx";
import LanderCardImage from "./LanderCardImage.tsx";
import LanderDesignElements from "./LanderDesignElements.tsx";
import LanderLogo from "./LanderLogo.tsx";

export default function Page() {
	const { open, onOpen, onClose } = useModal();

	return (
		<>
			{/* Fullscreen lander hero */}
			<section className="w-full h-screen relative overflow-hidden">
				<div className="mx-auto h-screen w-full flex flex-col items-center justify-center z-10">
					<LanderDesignElements />
					<Starfield />

					<LanderLogo className="z-20" />

					<div className="flex flex-row gap-4 animate-fade-in">
						<Button
							variant={ThemeButtonVariant.Outline}
							className="absolute top-5 right-5 z-20"
							href="/auth/login"
						>
							Agent Login
						</Button>
						{/* <Button
							variant={ThemeButtonVariant.Outline}
							onClick={onOpen}
						>
							Register
						</Button> */}
					</div>
				</div>
			</section>

			{/* Promotional section */}
			<CommonBackground className="flex flex-col items-center min-h-[500px] overflow-hidden">
				<div className="text-center mx-auto pt-32 pb-9 space-y-2">
					<h3 className="uppercase text-base font-semibold tracking-[.2rem]">
						Welcome to
					</h3>
					<h1 className="uppercase text-4xl sm:text-6xl font-extrabold font-heading tracking-base">
						Stringiverse
					</h1>
					<p className="text-sm">
						A revolutionary ARG journey that bridges imagination and reality.
					</p>
				</div>

				<Button className="mx-auto" size={ThemeSize.Large} onClick={onOpen}>
					Become an Agent
				</Button>

				<section className="z-20 md:max-w-4xl my-24 mx-box w-full">
					{/* biome-ignore lint/a11y/useMediaCaption: no */}
					<video controls className="aspect-video w-full mx-auto">
						<source
							type="video/mp4"
							src="https://cdn.stringiverse.com/promo.mp4"
						/>
					</video>
				</section>

				<section className="w-full grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-4 mx-auto pb-9 px-4 md:px-8 lg:px-16 mb-24">
					<LanderCardImage
						image={cardSecrets}
						imageAlt="Discover Secrets Card"
						title="Discover Secrets"
						description="Solve ciphers, unravel mysteries, and discover secrets."
						features={[
							["Exercise Power", "Do you know the extent of your influence?"],
							["Blame or Claim?", "Who the tide turns, whose fault is it?"],
							["Existential Quest", "Why are you here?"],
						]}
					/>
					<LanderCardImage
						image={cardCollaboration}
						imageAlt="Collaborative Missions Card"
						title="Collaborative Missions"
						description="Team up with players worldwide to unravel cosmic mysteries."
						features={[
							["Virtual Voyages", "Master telepathy and remote viewing"],
							["Together We Thrive", "Work with fellow agents to level up"],
							["Geocache Hunt", "Scour the globe for real hidden artifacts"],
						]}
					/>
					<LanderCardImage
						image={cardChallenges}
						imageAlt="Dynamic Challenges Card"
						title="Dynamic Challenges"
						description="Face puzzles and tasks both physical and digital."
						features={[
							["Crafting Life's Canvas", "Master creating your reality"],
							["Discover the Truth", "Learn Who You Really Are"],
							[
								"Beware: Poliarity's Play",
								"Expect resistance... just like in life",
							],
						]}
					/>
				</section>
			</CommonBackground>

			<Footer />
			<JoinModal open={open} onClose={onClose} />
		</>
	);
}
